import React, { useEffect } from 'react';
import AnalyticsStats from '../../analytics/AnalyticsStats';
import BackfillButton from '../../analytics/BackfillButton';
import './AnalyticsTab.css';

const AnalyticsTab = ({ 
    analyticsData, 
    analyticsLoading, 
    handleBackfillData, 
    backfillStatus 
}) => {
    // Minimal logging - only log state transitions and data size
    useEffect(() => {
        if (analyticsData && analyticsData.length > 0) {
            console.log(`Analytics data received: ${analyticsData.length} records`);
        }
    }, [analyticsData]);

    if (analyticsLoading) {
        return <div className="analytics-loading">Loading analytics data...</div>;
    }

    if (analyticsData.length === 0) {
        return (
            <div className="analytics-container">
                <div className="analytics-header">
                    <h3>User Analytics</h3>
                    <BackfillButton 
                        onBackfill={handleBackfillData}
                        status={backfillStatus}
                    />
                </div>
                
                {backfillStatus.message && (
                    <div className={`backfill-status ${backfillStatus.loading ? 'loading' : ''}`}>
                        {backfillStatus.message}
                    </div>
                )}
                
                <div className="analytics-info">
                    <p>Showing real user data from your database.</p>
                </div>
                
                <div className="empty-analytics">
                    <p>No analytics data available. Click "Generate Analytics" to generate data.</p>
                </div>
            </div>
        );
    }
    
    return (
        <div className="analytics-container">
            <div className="analytics-header">
                <h3>User Analytics</h3>
                <BackfillButton 
                    onBackfill={handleBackfillData}
                    status={backfillStatus}
                />
            </div>
            
            {backfillStatus.message && (
                <div className={`backfill-status ${backfillStatus.loading ? 'loading' : ''}`}>
                    {backfillStatus.message}
                </div>
            )}
            
            <div className="analytics-info">
                <p>Showing real user data from your database.</p>
            </div>
            
            <AnalyticsStats data={analyticsData[analyticsData.length - 1]} />
        </div>
    );
};

export default AnalyticsTab; 